module.exports = __webpack_public_path__ + "static/img/img_0.ae412a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_0.jpg
// module id = 95
// module chunks = 20